
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import Space from 'ui/Space'
import Link from 'ui/Link'
import ShowHide from 'ui/ShowHide'
import BulletList from 'ui/BulletList'
import Step from '../warehouse-setup-connect-step'

// TODO(stephenmathieson): move this ip to an env var
const SEGMENT_IP = '52.25.130.38/32'

class ConnectExistingDatabase extends Component {
  render () {
    const {
      stepOneTitle,
      stepOneInstructionsURL,
      stepOneBullets,
      stepTwoTitle,
      stepTwoCopy,
      stepTwoLinkText,
      stepTwoLinkURL
    } = this.getStepCopy()

    return (
      <div className='ConnectExistingDatabase'>
        <Step number='1' title={stepOneTitle}>
          Make sure you’re logging in with a user that has read and write permissions so that we can write to your database.
          <Space value='10' />

          <BulletList>
            {stepOneBullets.map((text, i) =>
              <li key={i}>
                {text}
              </li>
            )}
          </BulletList>
          <Space value='14' />
          <Link href={stepOneInstructionsURL} target='_blank' rel='external'>View Instructions</Link>
        </Step>

        <Step number='2' title={stepTwoTitle}>
          {stepTwoCopy}
          <Space value='10' />

          <ShowHide show={stepTwoLinkURL && stepTwoLinkText}>
            <Link href={stepTwoLinkURL} rel='external' target='_blank'>{stepTwoLinkText}</Link>
          </ShowHide>
          <Space value='14' />

          {this.props.children}
        </Step>
      </div>
    )
  }

  getStepCopy () {
    let stepOneTitle = ''
    let stepOneInstructionsURL = ''
    let stepOneBullets = []
    let stepTwoTitle = ''
    let stepTwoCopy = ''
    let stepTwoLinkText = ''
    let stepTwoLinkURL = ''

    switch (this.props.metadataSlug) {
      case 'postgres':
        stepOneTitle = 'Configure your Postgres database'
        stepOneInstructionsURL = 'https://segment.com/docs/warehouses/postgres/#permissioning-segment-to-rds'
        stepOneBullets = [
          `Whitelist the Segment IP (${SEGMENT_IP})`,
          'Create a user that has read/write permissions.'
        ]

        stepTwoTitle = 'Enter your credentials'
        stepTwoCopy = 'Copy and paste these credentials from your database provider into the form below. Remember to use credentials for a new user that has read-write access.'
        break
      case 'redshift':
        stepOneTitle = 'Configure your Amazon Redshift cluster'
        stepOneInstructionsURL = 'https://segment.com/docs/warehouses/redshift/#permissioning-segment-to-redshift'
        stepOneBullets = [
          `Whitelist the Segment IP (${SEGMENT_IP})`,
          'Create a user that has read/write permissions.'
        ]

        stepTwoTitle = 'Enter your credentials'
        stepTwoCopy = 'You’ll want to copy and paste these credentials from your warehouse provider. If you’re not sure where to go, you can follow this guide or you can invite someone else to help you.'
        break
      case 'bigquery':
        stepOneTitle = 'Configure your BigQuery project'
        stepOneInstructionsURL = 'https://segment.com/docs/warehouses/bigquery/'
        stepOneBullets = [
          'Add Segment service account as a "BigQuery User".',
          <p>If you`re new to BigQuery, redeem your $500 promo code: <Link href='https://goo.gl/7PL7Yu' target='_blank' rel='external'>goo.gl/7PL7Yu</Link></p>
        ]

        stepTwoTitle = 'Enter your credentials'
        stepTwoCopy = 'You’ll want to copy and paste these credentials from BigQuery. This should be a readable name (example: YourCompany-1234). If you’re not sure where to go, you can follow our guide or you can invite someone else to help you.'
        stepTwoLinkText = 'Where can I find BigQuery credentials?'
        stepTwoLinkURL = 'https://segment.com/docs/warehouses/bigquery/#setup'
        break
      default:
      // no default
    }

    return {
      stepOneTitle,
      stepOneInstructionsURL,
      stepOneBullets,
      stepTwoTitle,
      stepTwoCopy,
      stepTwoLinkText,
      stepTwoLinkURL
    }
  }
}

ConnectExistingDatabase.displayName = 'ConnectExistingDatabase'

ConnectExistingDatabase.propTypes = {
  children: PropTypes.element.isRequired,
  metadataSlug: PropTypes.string.isRequired
}

export default ConnectExistingDatabase



// WEBPACK FOOTER //
// ./pages/workspace-warehouses/components/connect-existing-database/index.js